// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"LV-z","inlineTitle":"MV-z","sponsoredAdsWrapper":"NV-z","marketplaceRecosWrapper":"OV-z"};